// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
import * as Control_Promise from "../Control.Promise/index.js";
import * as Effect_Uncurried from "../Effect.Uncurried/index.js";
var showModalBs5 = /* #__PURE__ */ (function () {
    var $0 = Effect_Uncurried.runEffectFn1($foreign["_showModalBs5"]);
    return function ($1) {
        return Control_Promise.toAffE($0($1));
    };
})();
var hideModalBs5 = /* #__PURE__ */ (function () {
    var $2 = Effect_Uncurried.runEffectFn1($foreign["_hideModalBs5"]);
    return function ($3) {
        return Control_Promise.toAffE($2($3));
    };
})();
export {
    _showModalBs5,
    _hideModalBs5
} from "./foreign.js";
export {
    showModalBs5,
    hideModalBs5
};
//# sourceMappingURL=index.js.map
